module.exports = __webpack_public_path__ + "1.0/img/index-huodong3.6fa410da.png";